var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaves = function SvgWaves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443,
    height: 1204,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#18c6b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.028 107.518c-14.177 123.795-61.379 239.389-195.593 260.717-69.82 11.092-156.272 16.495-207.004 72.95-95.82 106.649-.194 301.248 69.043 394.931 40.691 55.05 85.745 107.701 115.777 169.224 30.032 61.53 43.626 135.09 17.958 198.55 66.598.39 133.208.28 199.807.28V107.518z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.028 0s-115.172 27.736-99.704 171.272c15.467 143.524 40.644 385.175-110.648 519.618C103.934 805.296-62.471 971.416 27.214 1204.17h415.813z",
    opacity: 0.5
  }))));
};
export { SvgWaves as ReactComponent };